import React, { useState } from 'react';
import { ChevronDown, ShieldCheck, ArrowRight } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
import { useLocale } from '../utils/locale';
export function SafetyNetSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const locale = useLocale();
  const isAR = locale === 'ar';
  const faqs = [{
    question: '¿Necesito comprar suplementos o productos adicionales?',
    answer: `No. El protocolo funciona exclusivamente con lo que ya ${isAR ? 'tenés' : 'tienes'} en tu cocina. ${isAR ? 'No necesitás' : 'No necesitas'} suplementos, batidos, ni ningún producto extra. Es un cambio en la forma en que le das combustible a tu cuerpo, nada más.`
  }, {
    question: '¿Funciona si tengo menos de 30 años? ¿O más de 60?',
    answer: 'Sí. El protocolo está basado en biología celular, no en edad. Tus mitocondrias funcionan igual a los 25 que a los 65 — lo que cambia es el nivel de daño acumulado. Cuanto antes reinicies el sistema, mejor.'
  }, {
    question: '¿Cómo recibo el material?',
    answer: `Es 100% digital. Apenas ${isAR ? 'completás' : 'completas'} la compra, ${isAR ? 'recibís' : 'recibes'} acceso inmediato al manual completo en formato PDF. Lo ${isAR ? 'podés' : 'puedes'} leer desde tu celular, tablet o computadora. Sin esperas, sin envíos.`
  }, {
    question: '¿Es complicado de seguir?',
    answer: `Es un protocolo de 72 horas con instrucciones paso a paso. Cada día tiene indicaciones claras y simples. Si ${isAR ? 'sabés' : 'sabes'} leer, ${isAR ? 'podés' : 'puedes'} seguirlo. ${isAR ? 'No necesitás' : 'No necesitas'} experiencia previa ni conocimientos de nutrición.`
  }, {
    question: '¿Y después de las 72 horas qué pasa?',
    answer: 'Las 72 horas son el encendido del motor: es cuando tu cuerpo abandona el modo supervivencia y recupera su capacidad de producir energía limpia. A partir de ahí, el manual te guía en el Protocolo 16:8 de Mantenimiento para sostener esa claridad mental de forma indefinida. Lo que notarás en las semanas siguientes no es solo un cambio físico, sino una resiliencia cognitiva y una estabilidad energética que te permitirán operar a tu máximo nivel sin los "crashes" de la tarde.'
  }];
  const scrollToOffer = () => {
    const el = document.getElementById('oferta-final');
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="py-4 md:py-14 px-6 bg-white" data-id="element-247">
      <div className="max-w-3xl mx-auto" data-id="element-248">
        {/* FAQ */}
        <div className="mb-12 md:mb-16" data-id="element-249">
          <h2 className="text-3xl md:text-4xl font-bold text-navy text-center mb-8" data-id="element-250">
            Preguntas frecuentes
          </h2>

          <div className="space-y-3" data-id="element-251">
            {faqs.map((faq, index) => <div key={index} className="border border-navy/10 rounded-xl overflow-hidden bg-background" data-id="element-252">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between gap-4 p-5 text-left hover:bg-navy/[0.02] transition-colors" data-id="element-253">
                  <span className="text-lg font-semibold text-navy pr-4" data-id="element-254">
                    {faq.question}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-navy/40 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-255" />
                </button>
                <div className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-256">
                  <p className="px-5 pb-5 text-navy/70 leading-relaxed" data-id="element-257">
                    {faq.answer}
                  </p>
                </div>
              </div>)}
          </div>
        </div>

        {/* Cost of Inaction */}
        <div className="mb-12 md:mb-16" data-id="element-258">
          <div className="border border-navy/10 rounded-xl p-8 text-center bg-background" data-id="element-259">
            <p className="text-lg md:text-xl text-navy/80 leading-relaxed italic" data-id="element-260">
              "El verdadero costo no es el precio de este manual, sino{' '}
              <strong className="text-navy not-italic" data-id="element-261">
                seguir viviendo en piloto automático
              </strong>
              . {isAR ? 'Viví' : 'Vive'} la experiencia del cambio en{' '}
              <strong className="text-navy not-italic" data-id="element-262">72 horas</strong> o te
              devolvemos tu inversión."
            </p>
          </div>
        </div>

        {/* Guarantee Badge + Final Link */}
        <div className="flex flex-col items-center text-center" data-id="element-263">
          <div className="flex items-center gap-4 mb-6 bg-accent/5 border border-accent/20 rounded-2xl px-8 py-5" data-id="element-264">
            <ShieldCheck className="w-14 h-14 text-accent flex-shrink-0" data-id="element-265" />
            <div className="text-left" data-id="element-266">
              <p className="font-bold text-navy text-lg" data-id="element-267">
                Garantía de Satisfacción
              </p>
              <p className="text-navy/60 text-sm" data-id="element-268">
                7 días para probar sin riesgo
              </p>
            </div>
          </div>

          <a href="https://vitalfoco.com/cart/44177187733564:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="group inline-flex items-center gap-2 text-accent font-semibold text-lg hover:text-navy transition-colors" data-id="element-269">
            <span className="underline underline-offset-4 decoration-accent/40 group-hover:decoration-accent" data-id="element-270">
              Quiero resetear mi sistema ahora
            </span>
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-271" />
          </a>
        </div>
      </div>
    </section>;
}